// extracted by mini-css-extract-plugin
export default {"container":"Navbar2_container__U6LlI","container_wrap":"Navbar2_container_wrap__YhRD2","box":"Navbar2_box__LhXJf","header_noti_icons":"Navbar2_header_noti_icons__Z38Kx"};